
import * as THREE from 'three';
import * as marietta from '../../..';
import { mm2D, pix2D, Unit } from '../../graphicLibs/util/unit';
import { PointInfo } from '../../WalltoFittingInfo';
import * as graphicLibs from '../../../graphicLibs/index';
import { BUILDING_TYPE_MANSION, BUILDING_TYPE_HOUSE } from '../../../webcad/Constants';
import { ThreeView } from '../../../view3d/webcad';
import { AddBeam2D } from './AddBeam2D';
import { Point } from '../../graphicLibs/math/Point';

export type beamType = {
    shape: THREE.Vector2[]
    height: number;
}

export class AddRoom2D {

    constructor(private buildingType: number) {
        ;
    }

    
    /**
     * 2D図面追加（部屋）
     * */
    public execute(roomList: number[][], pointList: PointInfo[], floor: number) {
        
        const center2D = new THREE.Vector2(marietta.webcad.WebCADGlobal.LAYER_SIZE_W/2, marietta.webcad.WebCADGlobal.LAYER_SIZE_H/2);
                
        // 部屋のitemInfoCollectionを作成する
        const rooms: marietta.webcad.collection.ItemInfoCollection[] = [];
        for (let i = 0; i < roomList.length; i++) {
            const info: any = {};
            info.f = floor;
            info.id = 'rom00_00';
            info.guid = marietta.webcad.WebCADGlobal.getGuid();
            /** 梁 作成 */
            const obj = this.findBeam(roomList[i], pointList, floor);
            if (obj != null) new AddBeam2D(obj, floor).execute();
            /** 下げ天井 設定 */
            const droppedCeiling = this.getDroppedCeiling(roomList[i], pointList, floor);
            info.ceiling_hang_height = (droppedCeiling !== 0 && obj == null) ? droppedCeiling : undefined;
            const defaultRoomSetting = marietta.webcad.WebCADGlobal.getRoomConfig(info.id);
            info.shape = []; // dotList作成 
            for (let j = 0; j < roomList[i].length; j++) {
                const index = roomList[i][j];
                if (pointList[index].isDelete == true) continue;
                const dot = this.createDotList(pointList[index].point, defaultRoomSetting.wallType);
                const pix = <pix2D>new THREE.Vector2(center2D.x, center2D.y);
                const mm = <mm2D>new THREE.Vector2(pointList[index].point.x * 1000, pointList[index].point.z * 1000);
                // マンション
                if (this.buildingType == BUILDING_TYPE_MANSION) {
                    info.shape.push({
                        x: mm.x + Unit.convertPixtoMm(pix).x,
                        y: Unit.convertPixtoMm(pix).y - mm.y,
                        wall_type: dot.wall_type,
                    });
                } else {
                    info.shape.push({
                        x: Unit.convertMmtoPix(mm).x + pix.x,
                        y: pix.y - Unit.convertMmtoPix(mm).y,
                        wall_type: dot.wall_type,
                    });
                }
            }
            // 中点を調べる
            const vectorList = marietta.webcad.util.WebCADUtil.convertDotListToVector2D(info.shape);
            const textPos = new graphicLibs.utility.labelPosition().labelPosition(vectorList);
            const textPosition = new marietta.core.Point(textPos.x,textPos.y);
            info.text = {name: '', x: textPosition.x, y: textPosition.y, auto_layout: 1};
            rooms.push(info);
        }
        
        marietta.webcad.WebCADGlobal.webcad2Dmanager.displayLineMeasurement = false; // 寸法線非表示

        marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = true;
        marietta.webcad.util.WebcadJSONParser.reproduceRoomItem(rooms);
        marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects = false;

    }
    
    /**
     * 頂点リスト作成
     * */
    private createDotList(point: THREE.Vector3, wallType: number): marietta.webcad.collection.PointCollection {
        const mm = <mm2D>new THREE.Vector2(point.x * 1000, point.z * 1000);
        const x = Unit.convertMmtoPix(mm).x;
        const y = Unit.convertMmtoPix(mm).y;
        const dot: marietta.webcad.collection.PointCollection = new marietta.webcad.collection.PointCollection(x, y, wallType);
        dot.guid = marietta.webcad.WebCADGlobal.getGuid();

        return dot;
    }
    
    /**
     * 下げ天井値算出
     * */
    private getDroppedCeiling(roomIndexes: number[], pointList: PointInfo[], floor: number): number {
        let ceilingHeight: number = 0;
        if (floor == 1) ceilingHeight = Number(ThreeView.get().planmgr.autoData.Model.GetCeiling1());
        if (floor == 2) ceilingHeight = Number(ThreeView.get().planmgr.autoData.Model.GetCeiling2());
        if (floor == 3) ceilingHeight = Number(ThreeView.get().planmgr.autoData.Model.GetCeiling3());

        let height = 0;
        const walls = ThreeView.get().LidarManager.walls[floor - 1];
        for (let i = 0; i < roomIndexes.length; i++) {
            const index = roomIndexes[i];
            const wallIndex = Math.floor(index/2);
            if (pointList[index].isExist == false || pointList[index].isDelete == true || walls.length <= wallIndex) continue; // 実在する壁のみ考慮するため
            height = Math.max(walls[wallIndex].dimensions[1] * 1000, height);
        }

        if (height > 2500) height = 2500; // 2500mm以上の天井は2500mmに丸める

        return Math.abs(Math.round(ceilingHeight - height));
    }

    /**
     * 梁の検出 次のポイントより高さが低かったら梁を作成する
     * */
    private findBeam(roomIndexes: number[], pointList: PointInfo[], floor: number): beamType[] | null {
        
        const center2D = new THREE.Vector2(marietta.webcad.WebCADGlobal.LAYER_SIZE_W/2, marietta.webcad.WebCADGlobal.LAYER_SIZE_H/2);
        const walls = ThreeView.get().LidarManager.walls[floor - 1];

        const heightToLow = (find_: number[]): number[] => {
            find_ = find_.map((i: number, index: number, array: number[]) => {
                const height1 = walls[Math.floor(roomIndexes[find_[0]] / 2)].dimensions[1];
                const height2 = walls[Math.floor(roomIndexes[find[1]] / 2)].dimensions[1];
                if (height1 > height2) return i;
                return array[(index + 1) % array.length];
            });

            return find_;
        }

        // 低い壁の高さから平均値を出し、50mm単位にする。高い壁との差分を梁の高さとする
        const heightBeam = (i1: number, i2: number, i3: number, i4: number): number => {
            const height1 = walls[Math.floor(i1 / 2)].dimensions[1] * 1000;
            const height2 = walls[Math.floor(i2 / 2)].dimensions[1] * 1000;
            const height3 = walls[Math.floor(i3 / 2)].dimensions[1] * 1000;
            const height4 = walls[Math.floor(i4 / 2)].dimensions[1] * 1000;
            let res = (height2 + height3 + height4) / 3;
            if (0 < (res % 50) && (res % 50) < 25) res = res - (res % 50);
            else if (25 <= (res % 50)) res += (res % 50);
            const height = Math.abs(height1 - res);

            return height;
        }

        // 共有している頂点の高さが50mm以上異なる頂点を探す
        let find: number[] = [];
        for (let i = 0; i < roomIndexes.length; i++) {
            const index = roomIndexes[i];
            const wallIndex = Math.floor(index/2);
            if (pointList[index].isExist == false || pointList[index].isDelete == true || walls.length <= wallIndex) continue; // 実在する壁のみ考慮するため
            const next = roomIndexes[(i + 1) % roomIndexes.length];
            const wallNext = Math.floor(next/2);
            if (pointList[next].isExist == false || pointList[next].isDelete == true || walls.length <= wallNext) continue; // 実在する壁のみ考慮するため
            if (Math.abs(walls[wallIndex].dimensions[1] * 1000 - walls[wallNext].dimensions[1] * 1000) >= 50) find.push(i); // 50mm以上なら梁を作成する頂点のリストに入れる
        }

        // ２点以上かつ、偶数個 でないと作成しない
        if (find.length < 2 && find.length % 2 != 0) return null;        
        
        // 高い方が先に来るようにリスト順番変更
        find = heightToLow(find);

        // ３点先に高さ違いの壁が存在していたら作成する
        const createBeam: beamType[] = [];
        const deleteIndex: number[] = [];
        for (let i = 0; i < find.length; i += 2) {
            if ((find[i] + 3) % roomIndexes.length == find[(i + 1) % find.length]) {
                const pix = <pix2D>new THREE.Vector2(center2D.x, center2D.y);
                const i1 = roomIndexes[find[i]];
                const i2 = roomIndexes[(find[i] + 1) % roomIndexes.length];
                const i3 = roomIndexes[(find[i] + 2) % roomIndexes.length];
                const i4 = roomIndexes[find[(i + 1) % find.length]];
                const height = heightBeam(i1, i2, i3, i4);
                const p1 = pointList[Point.nextPoint(i1)].point.clone();
                const p2 = pointList[Point.nextPoint(i2)].point.clone();
                const p3 = pointList[Point.nextPoint(i3)].point.clone();
                const p4 = pointList[Point.nextPoint(i4)].point.clone();
                // マンション
                let shape: THREE.Vector2[];
                if (this.buildingType == BUILDING_TYPE_MANSION) {
                    shape = [
                        new THREE.Vector2(p1.x * 1000 + Unit.convertPixtoMm(pix).x, Unit.convertPixtoMm(pix).y - p1.z * 1000), 
                        new THREE.Vector2(p2.x * 1000 + Unit.convertPixtoMm(pix).x, Unit.convertPixtoMm(pix).y - p2.z * 1000), 
                        new THREE.Vector2(p3.x * 1000 + Unit.convertPixtoMm(pix).x, Unit.convertPixtoMm(pix).y - p3.z * 1000), 
                        new THREE.Vector2(p4.x * 1000 + Unit.convertPixtoMm(pix).x, Unit.convertPixtoMm(pix).y - p4.z * 1000)
                    ];
                } else {
                    const convertMMToPix = marietta.webcad.util.WebCADUtil.convertMMToPix; 
                    shape = [
                        new THREE.Vector2(convertMMToPix(p1.x * 1000) + pix.x, pix.y - convertMMToPix(p1.z * 1000)), 
                        new THREE.Vector2(convertMMToPix(p2.x * 1000) + pix.x, pix.y - convertMMToPix(p2.z * 1000)), 
                        new THREE.Vector2(convertMMToPix(p3.x * 1000) + pix.x, pix.y - convertMMToPix(p3.z * 1000)), 
                        new THREE.Vector2(convertMMToPix(p4.x * 1000) + pix.x, pix.y - convertMMToPix(p4.z * 1000))
                    ];
                }
                createBeam.push({
                    shape: shape,
                    height: height
                });
                deleteIndex.push(...[i, (i + 1) % find.length]);
            }
        }

        if (deleteIndex.length > 0) deleteIndex.forEach((index: number) => find.splice(index, 1));

        if (find.length < 4 && find.length % 2 != 0) return createBeam;
        
        // 高い方が先に来るようにリスト順番変更
        find = heightToLow(find);

        // 2頂点ずつ見ていって、軸平行の頂点があったら梁を作成する
        for (let i = 0; i < find.length; i+=2) {
            for (let j = 0; j < find.length; j+=2) {
                const i1 = roomIndexes[find[i]];
                const i2 = roomIndexes[(find[i] + 1) % roomIndexes.length];
                const i3 = roomIndexes[find[(j + 2) % find.length]];
                const i4 = roomIndexes[find[(j + 3) % find.length]];
                const height = heightBeam(i1, i2, i3, i4);
                const p1 = pointList[Point.nextPoint(i3)].point.clone();
                const p2 = pointList[Point.nextPoint(i4)].point.clone();
                const p3 = pointList[Point.nextPoint(i1)].point.clone();
                const p4 = pointList[Point.nextPoint(i2)].point.clone();
                const dir1 = p1.clone().sub(p4);
                const dir2 = p2.clone().sub(p3);
                const x = new THREE.Vector3(1, 0, 0);
                if ((x.clone().cross(dir1).y == 0 || x.clone().dot(dir1) == 0) && (x.clone().cross(dir2).y == 0 || x.clone().dot(dir2) == 0)) {
                    const pix = <pix2D>new THREE.Vector2(center2D.x, center2D.y);   
                    // マンション
                    let shape: THREE.Vector2[];
                    if (this.buildingType == BUILDING_TYPE_MANSION) {
                        shape = [
                            new THREE.Vector2(p1.x * 1000 + Unit.convertPixtoMm(pix).x, Unit.convertPixtoMm(pix).y - p1.z * 1000), 
                            new THREE.Vector2(p2.x * 1000 + Unit.convertPixtoMm(pix).x, Unit.convertPixtoMm(pix).y - p2.z * 1000), 
                            new THREE.Vector2(p3.x * 1000 + Unit.convertPixtoMm(pix).x, Unit.convertPixtoMm(pix).y - p3.z * 1000), 
                            new THREE.Vector2(p4.x * 1000 + Unit.convertPixtoMm(pix).x, Unit.convertPixtoMm(pix).y - p4.z * 1000)
                        ];
                    } else {
                        const convertMMToPix = marietta.webcad.util.WebCADUtil.convertMMToPix; 
                        shape = [
                            new THREE.Vector2(convertMMToPix(p1.x * 1000) + pix.x, pix.y - convertMMToPix(p1.z * 1000)), 
                            new THREE.Vector2(convertMMToPix(p2.x * 1000) + pix.x, pix.y - convertMMToPix(p2.z * 1000)), 
                            new THREE.Vector2(convertMMToPix(p3.x * 1000) + pix.x, pix.y - convertMMToPix(p3.z * 1000)), 
                            new THREE.Vector2(convertMMToPix(p4.x * 1000) + pix.x, pix.y - convertMMToPix(p4.z * 1000))
                        ];
                    }
                    createBeam.push({
                        shape: shape,
                        height: height
                    });
                }
            }
        }

        if (createBeam.length == 0) return null;

        return createBeam;
    }

}